import { useEffect, useRef } from "react";

// A sentinel element under the last card: when it scrolls into view (400px early) the
// next page is requested. `dep` re-arms the observer when the list changes length, so a
// short page that still leaves the sentinel on screen keeps loading.
export function useInfiniteScroll(hasMore: boolean, loadMore: () => void, dep: number) {
  const sentinel = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const node = sentinel.current;
    if (!node || !hasMore) return;
    const observer = new IntersectionObserver((entries) => entries.some((entry) => entry.isIntersecting) && loadMore(), { rootMargin: "400px" });
    observer.observe(node);
    return () => observer.disconnect();
  }, [hasMore, loadMore, dep]);
  return sentinel;
}
